import { createContainer } from 'react-sweet-state';

import { DebugStore } from './DebugStore';

export const DebugStoreContainer = createContainer(DebugStore, {
  onInit:
    () =>
    ({ setState }, { state }) => {
      if (state) {
        setState(state);
      }
    },
  onUpdate:
    () =>
    ({ setState }, { state }) => {
      if (state) {
        setState(state);
      }
    },
});
